import { render, staticRenderFns } from "./card-starts.vue?vue&type=template&id=a4be3074&"
import script from "./card-starts.vue?vue&type=script&lang=js&"
export * from "./card-starts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports